import { DomainDto } from '@halo/dtos/domain.dto'
import { AccountDto } from '@halo/dtos/account.dto'
import { PromptReferrerAllowType } from '@halo/enums/prompt-referrer-allow-type'
import { IGlobalPromptSettings } from '@halo/interfaces/global-prompt-settings'

export function calculateFromPromptFcapSeconds(config: any): number {
    let promptFcap = config.fcap_seconds

    switch (config.display_metric) {
        default:
        case 'days':
            promptFcap = promptFcap / 24
        case 'hours':
            promptFcap = promptFcap / 60
        case 'minutes':
            promptFcap = promptFcap / 60
    }

    return promptFcap
}

export function calculateToPromptFcapSeconds(values: any): number {
    let promptFcap = values.promptFcap

    switch (values.promptFcapDisplayMetric) {
        default:
        case 'days':
            promptFcap = promptFcap * 24
        case 'hours':
            promptFcap = promptFcap * 60
        case 'minutes':
            promptFcap = promptFcap * 60
    }

    return promptFcap
}

export function prepareGlobalPromptSettings(values: any, currentConfig: any): any {
    const config = {
        referrers: {
            enabled: false,
            when_self: PromptReferrerAllowType.IGNORE,
            when_blank: PromptReferrerAllowType.ALLOW,
            persist_ttl_seconds: 60 * 60 * 24 * 7,
            ...currentConfig?.referrers,
        },
    } as IGlobalPromptSettings

    config.referrers.enabled = values.referrerConditionsEnabled
    if (values.referrerConditionsEnabled) {
        config.referrers.when_blank = values.referrerWhenBlank || config.referrers.when_blank

        if (!values.referrerAllow || values.referrerAllow.length === 0) {
            delete config.referrers.allowed
        } else {
            const exact = values.referrerAllow
                .filter((pack: any) => pack.type === 'exact')
                .map((pack: any) => pack.value)

            const contains = values.referrerAllow
                .filter((pack: any) => pack.type === 'contains')
                .map((pack: any) => pack.value)

            config.referrers.allowed = config.referrers.allowed || {}
            config.referrers.allowed.exact = exact && exact.length > 0 ? exact : undefined
            if (config.referrers.allowed.exact === undefined) {
                delete config.referrers.allowed.exact
            }

            config.referrers.allowed.contains = contains && contains.length > 0 ? contains : undefined
            if (config.referrers.allowed.contains === undefined) {
                delete config.referrers.allowed.contains
            }
        }

        if (!values.referrerBlock || values.referrerBlock.length === 0) {
            delete config.referrers.blocked
        } else {
            const exact = values.referrerBlock
                .filter((pack: any) => pack.type === 'exact')
                .map((pack: any) => pack.value)

            const contains = values.referrerBlock
                .filter((pack: any) => pack.type === 'contains')
                .map((pack: any) => pack.value)

            config.referrers.blocked = config.referrers.blocked || {}
            config.referrers.blocked.exact = exact && exact.length > 0 ? exact : undefined
            if (config.referrers.blocked.exact === undefined) {
                delete config.referrers.blocked.exact
            }

            config.referrers.blocked.contains = contains && contains.length > 0 ? contains : undefined
            if (config.referrers.blocked.contains === undefined) {
                delete config.referrers.blocked.contains
            }
        }
    }

    return config
}

export function getFcapAndReferrerConfigs(entity: DomainDto | AccountDto): any {
    let defaultPromptFcapOccurrences = 1
    let defaultPromptFcapFrequency = 1
    let defaultPromptFcapDisplayMetric = 'days'
    let defaultReferrerAllowValue
    let defaultReferrerBlockValue
    let defaultReferrerWhenBlank = PromptReferrerAllowType.ALLOW

    if (entity) {
        if (entity.frequency_caps) {
            const promptConfig = entity.frequency_caps.prompt

            if (promptConfig) {
                defaultPromptFcapOccurrences = promptConfig.occurrences
                defaultPromptFcapFrequency = calculateFromPromptFcapSeconds(promptConfig)
                defaultPromptFcapDisplayMetric = promptConfig.display_metric
            }
        }

        if (entity.global_prompt_settings) {
            const referrerConfig = entity.global_prompt_settings.referrers

            if (referrerConfig) {
                defaultReferrerWhenBlank = referrerConfig.when_blank

                if (referrerConfig.allowed) {
                    defaultReferrerAllowValue = [].concat.apply(
                        [],
                        Object.keys(referrerConfig.allowed).map((type) =>
                            referrerConfig.allowed[type].map((value: string) => ({ type, value })),
                        ),
                    )
                }

                if (referrerConfig.blocked) {
                    defaultReferrerBlockValue = [].concat.apply(
                        [],
                        Object.keys(referrerConfig.blocked).map((type) =>
                            referrerConfig.blocked[type].map((value: string) => ({ type, value })),
                        ),
                    )
                }
            }
        }
    }

    return {
        defaultPromptFcapOccurrences,
        defaultPromptFcapFrequency,
        defaultPromptFcapDisplayMetric,
        defaultReferrerAllowValue,
        defaultReferrerBlockValue,
        defaultReferrerWhenBlank,
    }
}
